// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WyDptdWc0t {
  width: 369px;
  padding: 4px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.06);
  float: left;
  background: #fff;
}
.WyDptdWc0t h4 {
  line-height: 3em;
}
.WyDptdWc0t .ttUAq9CJ5p {
  float: left;
  width: 100%;
}
.WyDptdWc0t .YegpbnINIH {
  height: 40px;
  width: 60px;
  float: left;
  display: inline-block;
  min-height: 0;
  border-radius: 0;
  margin-bottom: 0;
  position: relative;
}
.WyDptdWc0t .YegpbnINIH:hover {
  cursor: pointer;
}
.WyDptdWc0t .YegpbnINIH:hover:after {
  position: absolute;
  content: "";
  z-index: 10;
  height: 40px;
  width: 60px;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.3);
}
.eXprEM2g3A .nZc860kS_u:focus {
  outline: none;
}
.eXprEM2g3A .nZc860kS_u.uCG8mrblq4.p3_aVkmVNw {
  background: #375A88;
}
.eXprEM2g3A .nZc860kS_u.uCG8mrblq4.p3_aVkmVNw span {
  color: #fff;
}
.eXprEM2g3A .p3_aVkmVNw {
  background: #F5F4F9;
  border: 1px solid rgba(0, 0, 0, 0.06);
  color: rgba(0, 0, 0, 0.2);
}
.eXprEM2g3A .p3_aVkmVNw:hover {
  background: #4F5157;
  color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
.eXprEM2g3A input {
  height: 38px;
  min-width: 220px;
}
.YegpbnINIH.TRfSN3hBoa {
  background: #410102;
}
.YegpbnINIH.BJFsKstAIS {
  background: #911318;
}
.YegpbnINIH.EV8lYHtXHH {
  background: #D8293B;
}
.YegpbnINIH.rjoyYHbcm0 {
  background: #F2373C;
}
.YegpbnINIH.Rg_EMFTC6x {
  background: #FC4448;
}
.YegpbnINIH.z_5RNaBAd6 {
  background: #ED535E;
}
.YegpbnINIH.cBn4UDpSqh {
  background: #E34926;
}
.YegpbnINIH.JSeMe1HQJJ {
  background: #FC562B;
}
.YegpbnINIH.spF6KqHiH4 {
  background: #FC6722;
}
.YegpbnINIH.Zsw1Leu4L8 {
  background: #FD7F24;
}
.YegpbnINIH.Gwtbb34zxP {
  background: #FD8D26;
}
.YegpbnINIH.KZf1Ds5qiG {
  background: #EC9C3E;
}
.YegpbnINIH.LVCmrwGXfO {
  background: #0e673a;
}
.YegpbnINIH.k3F4mg5siU {
  background: #208740;
}
.YegpbnINIH.SsoCaFDGSU {
  background: #239718;
}
.YegpbnINIH.YwE16gJIHZ {
  background: #55A84D;
}
.YegpbnINIH.w6NCO8WiZY {
  background: #4BBE5A;
}
.YegpbnINIH.dINijtJOBW {
  background: #0CCA6A;
}
.YegpbnINIH.TV0rpZrZdS {
  background: #0A3C64;
}
.YegpbnINIH.jnSUUbGPIv {
  background: #0d487a;
}
.YegpbnINIH.TgkmStR7pn {
  background: #10538d;
}
.YegpbnINIH.Ofekv76lIl {
  background: #115A99;
}
.YegpbnINIH.smn4q4ePXB {
  background: #3387E2;
}
.YegpbnINIH.Mbt1ILewQ8 {
  background: #1BA9CF;
}
.YegpbnINIH.uDmzIKlzMO {
  background: #d27c02;
}
.YegpbnINIH.gthNA7QgtC {
  background: #fb9402;
}
.YegpbnINIH.mKl6QiGRBV {
  background: #FD9B30;
}
.YegpbnINIH.rgtpbCjQ8m {
  background: #FDBE2D;
}
.YegpbnINIH.gwwWPmz_hK {
  background: #FED831;
}
.YegpbnINIH.dsaod7wowK {
  background: #FFFD38;
}
.YegpbnINIH.rSZ4CF2ILb {
  background: #2D215C;
}
.YegpbnINIH.iNZKE3Dbwm {
  background: #483C83;
}
.YegpbnINIH.a1kP3yUYh_ {
  background: #58518d;
}
.YegpbnINIH.tKhgj9q1gm {
  background: #7068A9;
}
.YegpbnINIH.KVnEQQYnGf {
  background: #7f78b2;
}
.YegpbnINIH.xIOVlhYUJH {
  background: #8f88bc;
}
.YegpbnINIH.XoGZIFNg96 {
  background: #000;
}
.YegpbnINIH.AxGTaSmmcU {
  background: #282626;
}
.YegpbnINIH.JMnJzbr0mz {
  background: #242222;
}
.YegpbnINIH.sHBKiB_tOT {
  background: #353838;
}
.YegpbnINIH.Mg8NHCvLvq {
  background: #666;
}
.YegpbnINIH.KOZcWN_fKw {
  background: #999;
}
.nWcY9ZxQhT {
  background: none;
  margin-top: 120px;
  position: relative;
  margin-left: 10px;
}
.nWcY9ZxQhT .dvoBPZaRYB {
  display: none;
}
.wMOmeeiKT5.wMOmeeiKT5 {
  width: auto;
  max-width: 1200px;
}
.wMOmeeiKT5.wMOmeeiKT5 .lAo24E4uej {
  position: relative;
  background-color: #375A87;
}
.wMOmeeiKT5.wMOmeeiKT5 .lAo24E4uej move-modal-header__ctn move-modal-header__title {
  font-size: 20px;
}
.wMOmeeiKT5.wMOmeeiKT5 .hQAZYvKMq1 {
  margin-right: 2px;
  font-size: 20px;
}
.wMOmeeiKT5.wMOmeeiKT5 .I0xvFZM3TP {
  margin-right: 2px;
  font-size: 28px !important;
}
.wMOmeeiKT5.wMOmeeiKT5 .D5khk7LKkL {
  position: absolute;
  top: 12px;
  right: 18px;
}
.QgeQocHdBY {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.QgeQocHdBY::-webkit-scrollbar {
  display: none;
}
.WST7S98Kb4 {
  display: flex;
  align-items: center;
  padding: 16px;
  justify-content: center;
}
.OpGjBtGVto .G8s4IX_WWd {
  line-height: 15px;
  margin-bottom: 12px;
}
.OpGjBtGVto .RoJUr3gaCp {
  min-width: 800px;
  padding: 12px 20px 12px;
  width: 100%;
}
.OpGjBtGVto .ihW9pcM_wK {
  width: 728px;
}
.OpGjBtGVto .CIkfRuZl1i,
.OpGjBtGVto .CIkfRuZl1i {
  background: none;
}
.OpGjBtGVto .CIkfRuZl1i > div:first-child,
.OpGjBtGVto .CIkfRuZl1i > div:first-child {
  font-size: 11px;
  font-style: normal;
  margin-left: 12px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color-picker": `WyDptdWc0t`,
	"color-row": `ttUAq9CJ5p`,
	"color-tile": `YegpbnINIH`,
	"picker-component": `eXprEM2g3A`,
	"picker-element": `nZc860kS_u`,
	"active": `uCG8mrblq4`,
	"btn": `p3_aVkmVNw`,
	"red-1": `TRfSN3hBoa`,
	"red-2": `BJFsKstAIS`,
	"red-3": `EV8lYHtXHH`,
	"red-4": `rjoyYHbcm0`,
	"red-5": `Rg_EMFTC6x`,
	"red-6": `z_5RNaBAd6`,
	"orange-1": `cBn4UDpSqh`,
	"orange-2": `JSeMe1HQJJ`,
	"orange-3": `spF6KqHiH4`,
	"orange-4": `Zsw1Leu4L8`,
	"orange-5": `Gwtbb34zxP`,
	"orange-6": `KZf1Ds5qiG`,
	"green-1": `LVCmrwGXfO`,
	"green-2": `k3F4mg5siU`,
	"green-3": `SsoCaFDGSU`,
	"green-4": `YwE16gJIHZ`,
	"green-5": `w6NCO8WiZY`,
	"green-6": `dINijtJOBW`,
	"blue-1": `TV0rpZrZdS`,
	"blue-2": `jnSUUbGPIv`,
	"blue-3": `TgkmStR7pn`,
	"blue-4": `Ofekv76lIl`,
	"blue-5": `smn4q4ePXB`,
	"blue-6": `Mbt1ILewQ8`,
	"yellow-1": `uDmzIKlzMO`,
	"yellow-2": `gthNA7QgtC`,
	"yellow-3": `mKl6QiGRBV`,
	"yellow-4": `rgtpbCjQ8m`,
	"yellow-5": `gwwWPmz_hK`,
	"yellow-6": `dsaod7wowK`,
	"purple-1": `rSZ4CF2ILb`,
	"purple-2": `iNZKE3Dbwm`,
	"purple-3": `a1kP3yUYh_`,
	"purple-4": `tKhgj9q1gm`,
	"purple-5": `KVnEQQYnGf`,
	"purple-6": `xIOVlhYUJH`,
	"black-1": `XoGZIFNg96`,
	"black-2": `AxGTaSmmcU`,
	"black-3": `JMnJzbr0mz`,
	"black-4": `sHBKiB_tOT`,
	"black-5": `Mg8NHCvLvq`,
	"black-6": `KOZcWN_fKw`,
	"picker-theme": `nWcY9ZxQhT`,
	"arrow-regular": `dvoBPZaRYB`,
	"move-review-modal__root": `wMOmeeiKT5`,
	"move-modal-header__root": `lAo24E4uej`,
	"move-modal-header__icon": `hQAZYvKMq1`,
	"move-modal-header__saveicon": `I0xvFZM3TP`,
	"move-modal-header__closeBtn": `D5khk7LKkL`,
	"move-review-modal__body": `QgeQocHdBY`,
	"move-modal-content__root": `WST7S98Kb4`,
	"move-review-project-select": `OpGjBtGVto`,
	"review-select__label": `G8s4IX_WWd`,
	"review-select__root": `RoJUr3gaCp`,
	"review-select__menuCtn": `ihW9pcM_wK`,
	"review-select__selectContainer": `CIkfRuZl1i`
};
export default ___CSS_LOADER_EXPORT___;
